import { useState, useEffect, useRef, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
// import { AuthContext } from "../../providers/AuthProvider";
import DropdownItem from "../../../../components/navigation/DropdownItem";

// icons
import { List, CalendarDays, Map } from "lucide-react";

// import { Icon } from "../../components/icons/Icon";
// import { chevronRight, chevronLeft, cog, info, blank } from "../icons/appIcons";
// import { logout, user } from "../icons/authIcons";

const ViewsDropdownMenu = ({ open, setOpen, taleId, ...otherProps }) => {
  const [activeMenu, setActiveMenu] = useState("main");
  const [menuHeight, setMenuHeight] = useState(null);
  const navigate = useNavigate();
  //   const { isLoggedIn } = useContext(AuthContext);
  // const [isOpen, setIsOpen] = useState(false);

  const location = useLocation();
  const prevKeyRef = useRef(location.key); // capture key on mount

  useEffect(() => {
    if (location.key !== prevKeyRef.current) {
      prevKeyRef.current = location.key; // update for next time
      if (open) setOpen(false);
    }
  }, [location.key, open, setOpen]);

  const toggleDropdown = (e) => {
    // e.preventDefault();
    setOpen(!open);
  };

  const primaryRef = useRef(null);
  const secondaryRef = useRef(null);

  /**
   * Calculate height of dropdown menu
   * @param {*} node
   */
  function calcElementHeight(node) {
    const height = node.offsetHeight;
    setMenuHeight(height);
  }

  return (
    <div
      id="views_dd_menu"
      className="left-dropdown"
      role="menu"
      style={{ height: menuHeight }}
    >
      <CSSTransition
        nodeRef={primaryRef}
        in={activeMenu === "main"} //this cannot be array, breaks submenu navigation
        timeout={500}
        classNames="dd-menu-primary"
        unmountOnExit
        onEnter={calcElementHeight}
      >
        <div className="dd-menu" ref={primaryRef}>
          <DropdownItem
            as="link"
            to={`/itinerary/${taleId}`}
            onSelect={toggleDropdown} // close menu after click
            leftIcon={<List size={20} />}
            className="dd-item"
          >
            Itinerary
          </DropdownItem>
          <DropdownItem
            as="link"
            to={`/map/${taleId}`}
            onSelect={toggleDropdown} // close menu after click
            leftIcon={<Map size={20} />}
            className="dd-item"
          >
            Map
          </DropdownItem>
          <DropdownItem
            as="link"
            to={`/calendar/${taleId}`}
            onSelect={toggleDropdown} // close menu after click
            leftIcon={<CalendarDays size={20} />}
            className="dd-item"
          >
            Calendar
          </DropdownItem>
        </div>
      </CSSTransition>
    </div>
  );
};

export default ViewsDropdownMenu;
